import { injectTypes } from '@/Types/InjectTypes';
import { guid } from '@/Utils';

export default {
    inject: {
        injectedFieldId: {
            from: injectTypes.fieldId,
            default: null,
        },
    },
    provide() {
        return {
            [injectTypes.fieldId]: this.fieldId,
        };
    },
    props: {
        id: { default: null, type: String },
        disabled: { default: false, type: Boolean },
        name: { default: null, type: String },
        placeholder: { default: null, type: [String, Number, Boolean] },
        readOnly: { default: false, type: Boolean },
        small: { default: false, type: Boolean },
        value: {},
    },
    data () {
        return {
            model: this.value,
            localId: guid(),
        };
    },
    computed: {
        fieldId() {
            return this.id || this.name || this.injectedFieldId || this.localId;
        },
    },
    methods: {
        focus() {
            if (this.$refs.input) {
                this.$refs.input.focus.apply(this.$refs.input);
            }
        },
        onBlur(evt) {
            this.$emit('blur', evt);
        },
        onFocus(evt) {
            this.$emit('focus', evt);
        },
        onKeydown(evt) {
            this.$emit('keydown', evt);
        },
    },
    watch: {
        'model' (newValue) {
            if (newValue !== this.value) {
                this.$emit('input', newValue);
            }
        },
        'value' (newValue) {
            this.model = newValue;
        },
    },
};
